/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TzResponseV2
 */
export interface TzResponseV2 {
  /**
   * The canonical time zone ID.
   *
   * In the event that multiple time zones could be returned,
   * the first one from the Unicode CLDR timezone.xml is returned.
   * @type {string}
   * @memberof TzResponseV2
   */
  tzId: string;
  /**
   * The total offset, in seconds, from UTC that is currently in effect for this time zone.
   *
   * This accounts for both the standard offset and any seasonal adjustments (e.g. DST).
   * @type {number}
   * @memberof TzResponseV2
   */
  utcOffset: number;
  /**
   * Whether Daylight Saving Time (or a similar seasonal offset) is in effect
   * at the queried timestamp.
   * @type {boolean}
   * @memberof TzResponseV2
   */
  isDst: boolean;
  /**
   * Integer non-leap seconds since January 1, 1970 (UNIX timestamp).
   *
   * If present, offsets will be calculated as of this time.
   * Otherwise, offsets will be effective as of the time of the query.
   * @type {number}
   * @memberof TzResponseV2
   */
  timestamp: number;
  /**
   * The local time expressed as an RFC 2822 timestamp (e.g. Tue, 1 Jun 2003 10:52:37 -0500).
   *
   * If a timestamp is included in the request, it will be localized here.
   * Otherwise, this will reflect the time of the request.
   *
   * NOTE: RFC 2822 is more restrictive than other formats and cannot represent all dates.
   * @type {string}
   * @memberof TzResponseV2
   */
  localRfc2822Timestamp?: string | null;
  /**
   * The local time expressed as an RFC 3339 (ISO 8601) timestamp (e.g. 2003-06-01T10:52:37+02:00).
   *
   * If a timestamp is included in the request, it will be localized here.
   * Otherwise, this will reflect the time of the request.
   * @type {string}
   * @memberof TzResponseV2
   */
  localRfc3339Timestamp: string;
}

/**
 * Check if a given object implements the TzResponseV2 interface.
 */
export function instanceOfTzResponseV2(value: object): value is TzResponseV2 {
  if (!("tzId" in value) || value["tzId"] === undefined) return false;
  if (!("utcOffset" in value) || value["utcOffset"] === undefined) return false;
  if (!("isDst" in value) || value["isDst"] === undefined) return false;
  if (!("timestamp" in value) || value["timestamp"] === undefined) return false;
  if (
    !("localRfc3339Timestamp" in value) ||
    value["localRfc3339Timestamp"] === undefined
  )
    return false;
  return true;
}

export function TzResponseV2FromJSON(json: any): TzResponseV2 {
  return TzResponseV2FromJSONTyped(json, false);
}

export function TzResponseV2FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TzResponseV2 {
  if (json == null) {
    return json;
  }
  return {
    tzId: json["tz_id"],
    utcOffset: json["utc_offset"],
    isDst: json["is_dst"],
    timestamp: json["timestamp"],
    localRfc2822Timestamp:
      json["local_rfc_2822_timestamp"] == null
        ? undefined
        : json["local_rfc_2822_timestamp"],
    localRfc3339Timestamp: json["local_rfc_3339_timestamp"],
  };
}

export function TzResponseV2ToJSON(json: any): TzResponseV2 {
  return TzResponseV2ToJSONTyped(json, false);
}

export function TzResponseV2ToJSONTyped(
  value?: TzResponseV2 | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tz_id: value["tzId"],
    utc_offset: value["utcOffset"],
    is_dst: value["isDst"],
    timestamp: value["timestamp"],
    local_rfc_2822_timestamp: value["localRfc2822Timestamp"],
    local_rfc_3339_timestamp: value["localRfc3339Timestamp"],
  };
}
